import { useState } from "react";

// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";

// @mui material components
import Menu from "@mui/material/Menu";
// import Grid from "@mui/material/Grid";

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftBox";
import NavbarLink from "components/Menu/NavbarLink";
import SoftButton from "components/SoftButton";
import { Link } from "react-router-dom";

import routes from "routes";

function DefaultNavbarMobile({ open, close }) {
  const { width } = open && open.getBoundingClientRect();

  return (
    <Menu
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "center",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "center",
      }}
      anchorEl={open}
      open={Boolean(open)}
      onClose={close}
      MenuListProps={{ style: { width: `calc(${width}px - 4rem)` } }}
    >
      <SoftBox px={0.5}>
        {routes
          .filter((el) => el.showInOutMenu)
          .map((el) => {
            if (el.href)
              return (
                <NavbarLink
                  href={el.href}
                  component="a"
                  name={el.name}
                  key={el.key}
                  light={false}
                  target="_blank"
                  rel="noreferrer"
                />
              );
            return <NavbarLink name={el.name} key={el.key} route={el.route} light={false} />;
          })}
      </SoftBox>
      <SoftBox display={{ lg: "inline-block" }}>
        <SoftButton
          component={Link}
          to="/login"
          variant="gradient"
          color="info"
          size="small"
          circular
          style={{ width: "100%" }}
        >
          ΣΥΝΔΕΣΗ
        </SoftButton>
      </SoftBox>
    </Menu>
  );
}

// Typechecking props for the DefaultNavbarMenu
DefaultNavbarMobile.propTypes = {
  routes: PropTypes.arrayOf(PropTypes.object).isRequired,
  open: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]).isRequired,
  close: PropTypes.oneOfType([PropTypes.func, PropTypes.bool, PropTypes.object]).isRequired,
};

export default DefaultNavbarMobile;
